/*
  Översätter Klaviyos "Back in stock"-knapp och popup till svenska.
  Klaviyo har bara ett formulär (på engelska), så vi byter texterna här
  när sidan visas på svenska. Laddas bara på svenska sidor (se theme.liquid).
  Ändras texterna i Klaviyo måste de engelska nycklarna nedan uppdateras.
*/
(function () {
  var texts = {
    'NOTIFY ME': 'MEDDELA MIG',
    'NOTIFY ME WHEN BACK IN STOCK': 'MEDDELA MIG NÄR DEN FINNS I LAGER IGEN',
    'Email': 'E-post',
    'Enter your email address': 'Ange din e-postadress',
    'I also accept to receive promotional marketing emails.': 'Jag vill även få nyhetsbrev och erbjudanden via e-post.',
    'Consent': 'Samtycke',
    "YOU'RE ALL SET": 'TACK!',
    'Keep an eye out for a back-in-stock message.': 'Vi meddelar dig via e-post så snart plagget finns i lager igen.',
    'This field is required': 'Fältet är obligatoriskt',
    'This email is invalid': 'E-postadressen är ogiltig',
    'Please enter a valid email address': 'Ange en giltig e-postadress'
  };

  function swap(value) {
    var key = value.trim();
    return texts[key] ? value.replace(key, texts[key]) : null;
  }

  function translate(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = swap(node.nodeValue);
      if (t) node.nodeValue = t;
    }
    root.querySelectorAll('input[placeholder], input[aria-label]').forEach(function (el) {
      ['placeholder', 'aria-label'].forEach(function (attr) {
        var v = el.getAttribute(attr);
        var t = v && swap(v);
        if (t) el.setAttribute(attr, t);
      });
    });
  }

  function run() {
    // QRHjLf = Klaviyo-formuläret "Back in Stock"
    document
      .querySelectorAll('#klaviyo-bis-button-container, form[data-testid="klaviyo-form-QRHjLf"]')
      .forEach(translate);
  }

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      run();
    }, 30);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  run();
})();
